<template>
  <div>
    <v-speed-dial
      v-model="fab"
      bottom
      direction="top"
      :open-on-hover="true"
      transition="slide-y-reverse-transition"
      id="FloatingButton"
    >
      <v-btn
        fab
        dark
        small
        style="background-color: #018389"
        @click="FloatingButtonAction1"
      >
        <!-- <v-icon title="Pregled troškova">euro</v-icon> -->

        <img
          data-v-68a7a11e=""
          title="Sumarno stanje magacina"
          src="../../assets/menuIcons/sigma.png"
        />
        

        <!-- <font-awesome-icon icon="fa-solid fa-bars" /> -->
      </v-btn>
      <v-btn
        fab
        dark
        small
        style="background-color: #018389"
        @click="FloatingButtonAction2"
      >
        <img
          data-v-68a7a11e=""
          title="Troškovi materijala kod lansiranja"
          src="../../assets/menuIcons/troskovi_lansiranja.png"
        />
      </v-btn>
      <v-btn
        fab
        dark
        small
        style="background-color: #018389"
        @click="FloatingButtonAction4"
      >
        <v-icon title="Ukupni troškovi materijala">euro</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        style="background-color: #018389"
        @click="FloatingButtonAction5"
      >
        <img
          data-v-68a7a11e=""
          title="Analitika nabavke"
          src="../../assets/menuIcons/nabavka.png"
        />
      </v-btn>
      <v-btn
        fab
        dark
        small
        style="background-color: #018389"
        @click="FloatingButtonAction6"
      >
        <img
          data-v-68a7a11e=""
          title="Analitika prodaje"
          src="../../assets/menuIcons/prodaja.png"
        />
      </v-btn>
      <v-btn
        fab
        dark
        small
        style="background-color: #018389"
        @click="FloatingButtonAction7"
      >
        <img
          data-v-68a7a11e=""
          title="Analitika izdavanja i otpisa"
          src="../../assets/menuIcons/izdavanje.png"
        />
      </v-btn>
      <v-btn
        fab
        dark
        small
        style="background-color: #018389"
        @click="FloatingButtonAction8"
      >
        <img
          class="material-symbols-outlined"
          title="Neiskorišćeni materijal po izdatnicama"
          src="../../assets/menuIcons/izdatnice.png"
        />
      </v-btn>
      <v-btn
        fab
        dark
        small
        style="background-color: #018389"
        @click="FloatingButtonAction3"
      >
        <v-icon title="Novi tip magacina">add</v-icon>
      </v-btn>
    </v-speed-dial>
    <div
      id="Dialog__Overlay--FloatingBtn"
      class="Dialog__Overlay v-overlay"
      style="z-index: 200"
    ></div>
    <div
      id="Dialog__Content--FloatingBtn"
      tabindex="-1"
      data-v-fae5bece=""
      class="Dialog__Content v-dialog__content"
    >
      <div
        id="Dialog"
        class="Dialog v-dialog v-dialog--active"
        v-bind:class="[makaClass]"
      >
        <div data-v-fae5bece="" class="v-card">
          <div
            data-v-fae5bece=""
            class="v-card__title headline lighten-2 v-card__title--primary"
          >
            <!-- Modal Titles  -->

            <div v-if="this.akcija === '1'">Stanje magacina</div>
            <div v-else-if="this.akcija === '2'">Troškovi materijala kod lansiranja</div>
            <div v-else-if="this.akcija === '4'">Ukupni troškovi materijala</div>
            <div v-else-if="this.akcija === '5'">Analitika nabavke</div>
            <div v-else-if="this.akcija === '6'">Analitika prodaje</div>
            <div v-else-if="this.akcija === '7'">Analitika izdavanja i otpisa</div>
            <div v-else-if="this.akcija === '8'">Neiskorišćeni materijal po izdatnicama</div>
            <div v-else-if="this.akcija === '3'">Novi tip magacina</div>
            <div v-else>Maka</div>

            <button
              id="closeModalBtn"
              @click="FloatingButtonAction"
              class="v-btn v-btn--flat white"
            >
              <v-icon>close</v-icon>
            </button>
          </div>

          <div data-v-fae5bece="" class="spacer"></div>

          <div v-if="this.akcija === '1'">
            <ReportWareHouseState
              @mounted="customMounted"
              :operationType="operationTypeLok"
            />
          </div>
          <div v-if="this.akcija === '2'">
            <ReportWareHouseCosts
              @mounted="customMounted"
              :operationType="operationTypeLok"
            />
          </div>
          <div v-if="this.akcija === '5'">
            <ReportWareHouseBuy
              @mounted="customMounted"
              :operationType="operationTypeLok"
            />
          </div>
          <div v-if="this.akcija === '6'">
            <ReportWareHouseSale
              @mounted="customMounted"
              :operationType="operationTypeLok"
            />
          </div>
          <div v-if="this.akcija === '7'">
            <ReportWareHouseIzdavanje
              @mounted="customMounted"
              :operationType="operationTypeLok"
            />
          </div>
          <div v-if="this.akcija === '4'">
            <ReportWareHouseMaterialCosts
              @mounted="customMounted"
              :operationType="operationTypeLok"
            />
          </div>
          <div v-if="this.akcija === '8'">
            <ReportWareHouseMaterialOutputCoast
              @mounted="customMounted"
              :operationType="operationTypeLok"
            />
          </div>
          <div v-else-if="this.akcija === '3'">
            <WareHouseType @mounted="customMounted"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { serverBus } from "../../main";

import ReportWareHouseCosts from "./../ReportWareHouseCosts";
import ReportWareHouseState from "./../ReportWareHouseState";
import ReportWareHouseSale from "./../ReportWareHouseSale";
import ReportWareHouseBuy from "./../ReportWareHouseBuy";
import ReportWareHouseMaterialCosts from "./../ReportWareHouseMaterialCosts";
import ReportWareHouseMaterialOutputCoast from "./../ReportWareHouseMaterialOutputCoast";
import ReportWareHouseIzdavanje from "./../ReportWareHouseIzdavanje";
import WareHouseType from "./../WareHouseTypePom";

const MountedMixin = {
  mounted() {
    // alert(222222);
    this.$emit("mounted");
  },
};

export default {
  name: "FloatingButton",
  dialog: false,

  data() {
    return {
      akcija: "1",
      tank_phase_vineId: 0,
      // idRoom: 0,
      makaClass: "maksimalna_velicina",

      direction: "top",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-x-reverse-transition",
      operationTypeLok: undefined,
    };
  },
  components: {
    ReportWareHouseCosts: (resolve) => {
      setTimeout(() => {
        const component = ReportWareHouseCosts;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    ReportWareHouseMaterialCosts: (resolve) => {
      setTimeout(() => {
        const component = ReportWareHouseMaterialCosts;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    ReportWareHouseMaterialOutputCoast: (resolve) => {
      setTimeout(() => {
        const component = ReportWareHouseMaterialOutputCoast;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    ReportWareHouseState: (resolve) => {
      setTimeout(() => {
        const component = ReportWareHouseState;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    ReportWareHouseSale: (resolve) => {
      setTimeout(() => {
        const component = ReportWareHouseSale;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    ReportWareHouseIzdavanje: (resolve) => {
      setTimeout(() => {
        const component = ReportWareHouseIzdavanje;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    ReportWareHouseBuy: (resolve) => {
      setTimeout(() => {
        const component = ReportWareHouseBuy;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    WareHouseType: (resolve) => {
      setTimeout(() => {
        const component = WareHouseType;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
  },
  methods: {
    FloatingButtonAction1(e) {
      
      this.operationTypeLok = 123;

      this.akcija = "1";
      this.FloatingButtonAction(e);
    },
    FloatingButtonAction2(e) {
      
      this.operationTypeLok = 125;

      this.akcija = "2";
      this.FloatingButtonAction(e);
    },
    FloatingButtonAction4(e) {
      
      this.operationTypeLok = 126;

      this.akcija = "4";
      this.FloatingButtonAction(e);
    },
    FloatingButtonAction5(e) {
      
      this.operationTypeLok = 127;

      this.akcija = "5";
      this.FloatingButtonAction(e);
    },
    FloatingButtonAction6(e) {
      
      this.operationTypeLok = 128;

      this.akcija = "6";
      this.FloatingButtonAction(e);
    },
    FloatingButtonAction7(e) {
      
      this.operationTypeLok = 129;

      this.akcija = "7";
      this.FloatingButtonAction(e);
    },
    FloatingButtonAction8(e) {
      
      this.operationTypeLok = 130;

      this.akcija = "8";
      this.FloatingButtonAction(e);
    },
    FloatingButtonAction3(e) {
      this.akcija = "3";
      this.FloatingButtonAction(e);
    },

    FloatingButtonAction(e) {
      const Dialog__Content = document.getElementById(
          "Dialog__Content--FloatingBtn"
        ),
        Dialog__Overlay = document.getElementById(
          "Dialog__Overlay--FloatingBtn"
        );

      let vueInstance = this;
      let isOpen = false;

      let akcijaPom = Number(this.akcija);

      let _this = this;

      function modalOpen() {
        if (!isOpen) {
          //// // console.log(e.target);
          if (e.target !== undefined) {
            vueInstance.$data.actionId = e.target.dataset.actionId;
          }

          Dialog__Content.style.display = "flex";
          Dialog__Content.classList += " v-dialog__content--active";
          Dialog__Overlay.style.display = "block";
          Dialog__Overlay.classList += " v-overlay--active";

          if (akcijaPom === 3) {
            serverBus.$emit("warehouse_types");
          }
          
          isOpen = true;
        }
      }

      function modalClose() {
        serverBus.$off("warehouse_types");

        Dialog__Content.style.display = "none";
        Dialog__Content.classList.remove("v-dialog__content--active");
        Dialog__Overlay.style.display = "none";
        Dialog__Overlay.classList.remove("v-overlay--active");

        isOpen = false;

        // alert("maka");
        // serverBus.$emit("osvezi_meni");

        _this.operationTypeLok = undefined;
      }

      if (e.target !== undefined) {
        if (e.target.nodeName !== "UL" && e.target.nodeName !== "DIV") {
        }

        /**
         * Close Modal
         */
        if (e.target.id === "closeModalBtn") {
          modalClose();
        } else {
          /**
           * Open Modal
           */
          modalOpen();
        }
      } else {
        alert(e);
      }
    },
    customMounted() {},
  },
  mounted() {
    

    this.akcija = this.$parent.floating_akcija;
  },
};
</script>
<style scoped lang='scss'>
// @import "./../parts/../../assets/sass/parts/modalStyles";
@import "./../parts/../../assets/sass/parts/modalStyles_siri_modal";

/*#Dialog {*/
/*max-width: 700px;*/
/*&__Overlay {*/
/*display: none;*/
/*z-index: 201;*/
/*}*/
/*&__Content {*/
/*display: none;*/
/*z-index: 202;*/
/*.v-card__title {*/
/*padding-left: 30px;*/
/*padding-bottom: 0;*/
/*}*/
/*.container {*/
/*padding-top: 0;*/
/*}*/
/*}*/
/*}*/

/*.v-card__title {*/
/*padding-top: 15px;*/
/*justify-content: space-between;*/
/*}*/

/*#closeModalBtn {*/
/*width: 70px;*/
/*&:before {*/
/*background-color: transparent;*/
/*}*/
/*}*/

#FloatingButton {
  background-image: url("../../assets/menuIcons/burger-menu-slim.png");
  background-position: center;
  position: fixed;
  right: 10px;
  bottom: 20px;
  width: 54px;
  height: 54px;
  font-size: 40px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;
  @media (max-width: 1200px) {
    height: 71px;
    padding-top: 10px;
    padding-right: 55px;
  }
  p {
    position: relative;
    width: 100%;
    height: 100%;
    i {
      position: absolute;
      left: 15px;
      top: 15px;
      transform: rotate(45deg);
      color: #ffffff;
    }
  }
  &:active,
  &:focus {
    box-shadow: none;
  }
}

#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}

button:hover{
  transform:scale(1.3);
  transition: all .4s ease-in-out;
}

</style>